// Domain to organization mapping
const DOMAIN_ORG_MAP = {
  "tuxedocamp.beclutch.club": "tuxedo",
  "warwick.beclutch.club": "warwick",
  "yaccamp.beclutch.club": "yac",
  // Development domains
  "devtuxedocamp.beclutch.club": "tuxedo",
  "devwarwick.beclutch.club": "warwick",
  "devyaccamp.beclutch.club": "yac"
};

// Payment configurations for each organization
// NOTE: These are development/sandbox credentials
// Production credentials will be provided by the client and should be updated accordingly
const PAYMENT_CONFIGS = {
  stax: {
    yac: {
      // Development/Sandbox credentials

      // Prod Stax credentials
      REACT_APP_FM_KEY: "Sierralingo-LLC-f9af7d4ee46d",
      REACT_APP_API_KEY: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJnb2RVc2VyIjpmYWxzZSwibWVyY2hhbnQiOiI5YjYzNjE1ZC1hNjYzLTRkMmYtODQyZi0yYjY1NDk4OGEyZTQiLCJzdWIiOiJlNjYzYjdmMS0zNTQ4LTQ2MjktYmVlYi1mMGFhZDBjZWNmMDgiLCJicmFuZCI6ImZhdHRtZXJjaGFudCIsImlzcyI6Imh0dHA6Ly9hcGlwcm9kLmZhdHRsYWJzLmNvbS90ZWFtL2FwaWtleSIsImlhdCI6MTYyNTc3Nzk4NCwiZXhwIjo0Nzc5Mzc3OTg0LCJuYmYiOjE2MjU3Nzc5ODQsImp0aSI6IlNxbjZVV042MHB6T0VhbG4iLCJhc3N1bWluZyI6ZmFsc2V9._DW8SG89K-CxB48xemjJcUIBkzM-Gz1bMxcj3Ohb-_c"
    },
    tuxedo: {
      // Tuxedo uses Forte
    },
    warwick: {
      // Warwick uses Forte
    }
  },
  forte: {
    tuxedo: {
      // Development/Sandbox credentials
      REACT_APP_FORTE_TRANSACTION_API: process.env.REACT_APP_FORTE_TRANSACTION_API_TUXEDO,
      REACT_APP_LOGIN_ID: process.env.REACT_APP_LOGIN_ID_TUXEDO,
      REACT_APP_TRANSACTION_KEY: process.env.REACT_APP_TRANSACTION_KEY_TUXEDO,
      REACT_APP_API_ACCESS_ID: process.env.REACT_APP_API_ACCESS_ID_TUXEDO,
      REACT_APP_API_SECURE_KEY: process.env.REACT_APP_API_SECURE_KEY_TUXEDO,
      REACT_APP_ORGANIZATION_ID: process.env.REACT_APP_ORGANIZATION_ID_TUXEDO,
      REACT_APP_LOCATION_ID: process.env.REACT_APP_LOCATION_ID_TUXEDO,
      REACT_APP_FORTE_AUTH_TOKEN: process.env.REACT_APP_FORTE_AUTH_TOKEN_TUXEDO
    },
    warwick: {
      // Development/Sandbox credentials
      REACT_APP_FORTE_TRANSACTION_API: process.env.REACT_APP_FORTE_TRANSACTION_API_WARWICK,
      REACT_APP_LOGIN_ID: process.env.REACT_APP_LOGIN_ID_WARWICK,
      REACT_APP_TRANSACTION_KEY: process.env.REACT_APP_TRANSACTION_KEY_WARWICK,
      REACT_APP_API_ACCESS_ID: process.env.REACT_APP_API_ACCESS_ID_WARWICK,
      REACT_APP_API_SECURE_KEY: process.env.REACT_APP_API_SECURE_KEY_WARWICK,
      REACT_APP_ORGANIZATION_ID: process.env.REACT_APP_ORGANIZATION_ID_WARWICK,
      REACT_APP_LOCATION_ID: process.env.REACT_APP_LOCATION_ID_WARWICK,
      REACT_APP_FORTE_AUTH_TOKEN: process.env.REACT_APP_FORTE_AUTH_TOKEN_WARWICK
    },
    yac: {
      // YAC uses Stax
    }
  }
};

/**
 * Get the organization name from a domain
 * @param {string} domain - The domain to check
 * @returns {string|null} The organization name or null if not found
 */
const getOrganizationFromDomain = (domain) => {
  return DOMAIN_ORG_MAP[domain] || null;
};

/**
 * Get payment configuration based on domain and merchant type
 * @param {string} domain - The current domain
 * @param {string} merchant - The merchant type ("stax" or "forte")
 * @returns {Object|null} The payment configuration or null if not found
 */
const getPaymentConfig = (domain, merchant) => {
  const org = getOrganizationFromDomain(domain);
  if (!org) {
    console.error(`No organization found for domain: ${domain}`);
    return null;
  }

  const paymentType = merchant === "stax" ? "stax" : "forte";
  const config = PAYMENT_CONFIGS[paymentType]?.[org];

  if (!config) {
    console.error(`No ${paymentType} configuration found for organization: ${org}`);
    return null;
  }

  return config;
};

/**
 * Check if the current configuration is for Stax
 * @param {string} merchant - The merchant type
 * @returns {boolean} True if the configuration is for Stax
 */
const isStaxConfig = (merchant) => {
  return merchant === "stax";
};

export {
  getPaymentConfig,
  getOrganizationFromDomain,
  isStaxConfig
}; 